import React, { Fragment } from 'react';

import cx from 'classnames';
import { isEmpty } from 'ramda';

import { FontAwesomeIcon } from 'components/shared/Icon/FontAwesome';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import { isDefined } from 'utils/ramda';

import { EEventType } from '../../types';
import s from './index.module.css';
import { IEventsProps } from './types';

export const Events = ({ icon, content, label, activeType }: IEventsProps) => {
  const showLabel = Array.isArray(label) ? !isEmpty(label) : isDefined(label);
  const { isMobile } = useMediaBreakpoints();

  return (
    <div
      className={s.content}
      style={{
        // @ts-expect-error TODO Refactor
        '--labelHeight': isMobile && showLabel && Array.isArray(label) ? `${(label.length - 1) * 27}px` : '27px',
      }}
    >
      <div className={cx(s.icon, { [s.hideIcon]: activeType !== EEventType.All, [s.iconWithLabel]: showLabel })}>
        <FontAwesomeIcon className={icon} />
      </div>
      <div className={s.eventDetails}>
        {showLabel &&
          (Array.isArray(label) ? (
            <div className={s.labels}>
              {label.map((el, idx) => (
                <Fragment key={idx}>{el}</Fragment>
              ))}
            </div>
          ) : (
            label
          ))}
        {content}
      </div>
    </div>
  );
};
